module.exports = __webpack_public_path__ + "54cf98f5/img/pdf-icon.79f04a36.svg";